import type { Value } from 'modules/core/components/MultiFilters/hooks/utils/defaultEvaluators'

import variables from 'modules/documents/store/collections/variables'
import type Variable from 'modules/documents/store/models/Variable'

export default (variable: Variable, value: Value) => {
  const currentVariable = variables.byVariable(variable.attributes.variable)

  if (!currentVariable) return

  switch (value) {
    case 'name':
      return variable.attributes.name

    case 'section':
      return variable.attributes.section

    case 'legal_entities':
      return variable.attributes.legal_entities[0]

    case 'variable':
      return variable.attributes.variable
  }
}
